module.exports = __webpack_public_path__ + "static/media/logoNew.8950242f.png";